var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"96","height":"96","fill":"none","viewBox":"0 0 96 96"}},[_c('path',{attrs:{"fill":"currentColor","d":"M95 54.143H55.143V94H41.857V54.143H2V40.857h39.857V1h13.286v39.857H95v13.286Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }